import { Box } from '@mui/material'
import { useCustomModelDraft } from '@/features/mockModel/useCustomModelDraft'
import CustomModelFields from './CustomModelFields'
import CustomModelFooter from './CustomModelFooter'
import CustomModelHeader from './CustomModelHeader'
import ProviderTiles from './ProviderTiles'
import styles from './customModelDialog.module.scss'

export default function CustomModelForm({ saved, onClose, onSave, onRemove }) {
  const form = useCustomModelDraft(saved)
  const submit = (event) => {
    event.preventDefault()
    const next = form.submit()
    if (next) onSave(next)
  }

  return (
    <Box component="form" className={styles.form} onSubmit={submit} noValidate>
      <CustomModelHeader onClose={onClose} />
      <Box className={styles.body}>
        <ProviderTiles value={form.draft.provider} onChange={form.pickProvider} />
        <CustomModelFields form={form} saved={saved} />
      </Box>
      <CustomModelFooter canRemove={Boolean(saved)} onRemove={onRemove} onClose={onClose} />
    </Box>
  )
}
